/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

/*获取经销商信息列表数据*/
export function getDealerList(param) {
  return request(`${config.server}/api/v1/dms/dmsCustomerMessage/list`, {
    method: 'post',
    body: {...param}
  });
}

/*删除*/
export function deleteList(id) {
    return request(`${config.server}/api/v1/dms/dmsCustomerMessage/delete?id=${id}`, {
        method: 'get'
    });
}

/*修改*/
export function update(param) {
    return request(`${config.server}/api/v1/dms/dmsCustomerMessage/update`, {
        method: 'post',
        body: param
    });
}

/*新增*/
export function insert(param) {
    return request(`${config.server}/api/v1/dms/dmsCustomerMessage/insert`, {
        method: 'post',
        body: {...param}
    });
}




// WEBPACK FOOTER //
// ./src/service/dealer/index.js